import React, { useEffect, useState, useContext } from "react";
import CartContext from "./CartContext";
import { Carousel } from "react-bootstrap";

/**
 * HomeCarousels (functional)
 * - Keeps same logic: picks mobile if width <= 1200, desktop otherwise
 * - Uses CartContext to build image URLs exactly as before
 * - Uses arrays + map to avoid repetition
 * - Adds resize listener for responsiveness and cleans it up
 */
export function HomeCarousels(props) {
  const context = useContext(CartContext);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 1200 : false
  );

  useEffect(() => {
    // update isMobile on resize
    function handleResize() {
      setIsMobile(window.innerWidth <= 1200);
    }
    window.addEventListener("resize", handleResize);
    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // base blob URL from context (same call as your class component)
  const base = context.GetEcSettingValueByName("StorageBlobImageUrl") || "";

  // filenames arrays (keeps same filenames you had)
  const mobileFiles = [
    "carouselMobile1.png",
    "carouselMobile2.png",
    "carouselMobile3.png",
    "carouselMobile4.png",
    "carouselMobile5.png",
    "carouselMobile6.png",
    "carouselMobile7.png",
    "carouselMobile8.png",
    "carouselMobile9.png",
    "carouselMobile10.png",
    "carouselMobile11.png",
  ];

  const desktopFiles = [
    "carousel1.png",
    "carousel2.png",
    "carousel3.png",
    "carousel4.png",
    "carousel5.png",
    "carousel6.png",
    "carousel7.png",
    "carousel8.png",
    "carousel9.png",
    "carousel10.png",
  ];

  const files = isMobile ? mobileFiles : desktopFiles;
  const imgClass = isMobile
    ? "d-block carouselimgmobile w-100"
    : "d-block carouselimg w-100";

  return (
    <Carousel fade onSelect={() => {}} touch={true}>
      {files.map((fn, idx) => (
        <Carousel.Item interval={1500} key={fn + "-" + idx}>
          <img
            className={imgClass}
            src={base + fn}
            alt={`Slide ${idx + 1}`}
            loading="lazy"
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
